import { gql } from '@apollo/client';

import { FinishedPracticeSession } from '../../types';
import { studentFinishedPracticeSessionFragment } from '@ts-core/modules/practice/graphql/fragments';

export interface GetPracticeSessionDetailsQueryVariables {
  courseId: string;
  practiceSessionId: string;
}

export interface GetPracticeSessionDetailsQueryResult {
  finishedPracticeSession: FinishedPracticeSession;
}

export const getPracticeSessionDetailsQuery = gql`
  query GetPracticeSessionDetailsQuery($courseId: String!, $practiceSessionId: String) {
    finishedPracticeSession(courseId: $courseId, practiceSessionId: $practiceSessionId)
      @rest(type: "StudentFinishedPracticeSession", path: "courses/{args.courseId}/practice/{args.practiceSessionId}/results") {
      ...StudentFinishedPracticeSession
    }
  }
  ${studentFinishedPracticeSessionFragment}
`;
